import React, {useState} from 'react';
import {isChrome, isEdge, isWindows} from 'react-device-detect';
import {FlatList, LogBox, TouchableOpacity, View} from 'react-native';

const ModulSlidesList = ({
   ListHeaderComponent,
   data,
   renderItem,
   onSelect,
   ItemSeparatorComponent,
   isLandscapemode,
}) => {
   const [selected, setSelected] = useState(false);

   const [containerHeight, setContainerHeight] = useState(0);
   const [isScrollable, setIsScrollable] = useState(false);

   const handleContentSizeChange = (contentWidth, contentHeight) => {
      setIsScrollable(contentHeight > containerHeight);
   };

   const handlePress = (item, index) => {
      setSelected(item);
      onSelect(item, index);
   };

   const renderItemWithSelection = ({item, index}) => {
      return (
         <TouchableOpacity onPress={() => handlePress(item, index)}>
            {renderItem({
               item,
               index,
               isScrollable,
            })}
         </TouchableOpacity>
      );
   };

   return (
      <View
         style={{flex: 1}}
         onLayout={event => {
            const {height} = event.nativeEvent.layout;
            setContainerHeight(height);
         }}>
         <FlatList
            ListHeaderComponent={ListHeaderComponent}
            data={data}
            renderItem={renderItemWithSelection}
            ItemSeparatorComponent={ItemSeparatorComponent}
            onContentSizeChange={handleContentSizeChange}
            style={{
               backgroundColor: '#202020',
               marginHorizontal: isWindows && (isChrome || isEdge) ? 24 : null,
               paddingBottom: isLandscapemode ? 12 : 0,
            }}
         />
      </View>
   );
};

export default ModulSlidesList;
